import React from 'react';
import PropTypes from 'prop-types';
import {
    AT_TABLE,
    COLLECTION,
    EAT_IN,
    DELIVERY,
    COLLECTION_EAT_IN,
    COLLECTION_DELIVERY,
    COLLECTION_ONLY,
    DELIVERY_ONLY,
    EAT_IN_ONLY
} from '../modules/constants';

const INSTORE_CLASS = 'instore';
const TAKEOUT_CLASS = 'takeout';

/**
 * Displays labels on menu items and in PDP if the item in question is conditionally available.
 * Performs logic to display either nothing, or In store/Delivery only labels.
 * @function
 * @param       {array} fulfilmentTypes Array of fulfilment types from API
 * @constructor
 */
function Fulfilment({ fulfilmentTypes }) {
    let className = null;
    let fulfilmentLabel = null;
    if (fulfilmentTypes === [COLLECTION, EAT_IN].join()) {
        fulfilmentLabel = COLLECTION_EAT_IN;
        className = INSTORE_CLASS;
    }

    if (fulfilmentTypes === [COLLECTION, DELIVERY].join()) {
        fulfilmentLabel = COLLECTION_DELIVERY;
        className = INSTORE_CLASS;
    }

    if (fulfilmentTypes === COLLECTION) {
        fulfilmentLabel = COLLECTION_ONLY;
        className = TAKEOUT_CLASS;
    }

    if (fulfilmentTypes === DELIVERY) {
        fulfilmentLabel = DELIVERY_ONLY;
        className = TAKEOUT_CLASS;
    }

    if (fulfilmentTypes === [AT_TABLE, EAT_IN].join()) {
        fulfilmentLabel = EAT_IN_ONLY;
        className = INSTORE_CLASS;
    }

    if (fulfilmentTypes === EAT_IN) {
        fulfilmentLabel = EAT_IN_ONLY;
        className = INSTORE_CLASS;
    }

    if (!fulfilmentLabel) {
        return null;
    }

    return <i className={className}>{fulfilmentLabel}</i>;
}

Fulfilment.propTypes = {
    fulfilmentTypes: PropTypes.string
};

export { Fulfilment };
